import { viewport } from '../../../utils/viewport';

class ChartHbar2 {
  constructor(el) {
    this.el = el;
    this.fills = el.querySelectorAll('.chart-hbar-2__item-fill');
    this.max = 0;

    viewport.observe(this.el, () => {
      if (!this.chart) {
        this.init();
      }
    });
  }

  init() {
    this.fills.forEach((fill) => {
      if (+fill.dataset.value > this.max) {
        this.max = +fill.dataset.value;
      }
    });

    this.fills.forEach((fill) => {
      fill.style.width = (fill.dataset.value / this.max) * 100 + '%';
    });
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.chart-hbar-2').forEach((el) => new ChartHbar2(el));

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview', ($block, attributes) => {
    $block.find('.chart-hbar-2').each((i, el) => new ChartHbar2(el, attributes));
  });
}